function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";
import styled from "styled-components";
import { space, color } from "styled-system";
var Svg = styled("svg")({
  flex: "none"
}, space, color);
var SvgVibe = React.forwardRef(function (props, ref) {
  return React.createElement(Svg, _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "currentcolor",
    height: props.size,
    width: props.size,
    ref: ref
  }), React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z",
    fill: "inherit"
  }), React.createElement("path", {
    d: "M16.973 12.688c.547.147 1.087.318 1.573.617.216.133.418.289.6.464.27.3.252.617.006.934-.216.276-.51.452-.823.6-.792.381-1.632.598-2.49.727-.697.105-1.405.165-2.107.253a.255.255 0 00-.162.112c-.492.733-.978 1.468-1.47 2.202-.04.049-.076.1-.108.153-.52-.78-1.034-1.563-1.543-2.35a.246.246 0 00-.21-.123c-1.405-.1-2.79-.282-4.117-.757-.42-.147-.822-.33-1.17-.605-.02-.018-.043-.03-.06-.048-.51-.428-.523-.886-.03-1.327.39-.353.87-.552 1.368-.705.498-.153 1.002-.264 1.506-.393.024-.006.048-.006.09-.018-1.086-1.662-2.16-3.307-3.26-4.975.067-.006.115-.012.157-.012.679-.006 1.357 0 2.035-.006a.245.245 0 01.234.135c1.642 2.505 3.283 5.01 4.922 7.519a.732.732 0 00.084.117c.378-.57.744-1.116 1.104-1.662 1.32-1.995 2.64-3.988 3.961-5.98.048-.07.084-.123.192-.123.714.006 1.429.006 2.143.006.034 0 .067.002.102.006-1.114 1.681-2.23 3.361-3.35 5.04.283.07.553.129.823.2zm-10.3 1.41c.14.156.304.29.487.393.75.4 1.578.546 2.437.675-.012-.04-.012-.058-.018-.07-.487-.734-.967-1.474-1.453-2.208a.174.174 0 00-.15-.047 6.974 6.974 0 00-.834.335 1.671 1.671 0 00-.462.376.388.388 0 00-.006.546zm9.454.634c.327-.088.626-.258.87-.493.24-.24.24-.511 0-.758a.92.92 0 00-.204-.165c-.258-.129-.528-.252-.793-.38-.09-.048-.143-.013-.197.07-.283.435-.57.862-.859 1.292-.18.27-.36.546-.546.828a.578.578 0 00.145 0c.527-.129 1.062-.247 1.584-.394zm.006-7.982l-4.111 6.549L7.856 6.75h8.277z",
    fill: "white"
  }));
});
SvgVibe.displayName = "SvgVibe";
SvgVibe.defaultProps = {
  size: 24,
  color: "#338BE5"
};
export default SvgVibe;